var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup',{attrs:{"close-action":_vm.popupClosed,"buttons":[{
    title: 'הבנתי, תודה',
    action: this.continueWithoutSelected,
    variant: 'secondary',
    size: 'slim',
  }]},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('img',{staticClass:"generic-failure-asset-in-popup",attrs:{"src":require('@/assets/bank-connection-failure.png')}}),_vm._v(" "),_c('div',{staticClass:"popup-title"},[_vm._v(_vm._s(_vm.popupTitle))])]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticClass:"description"},[_vm._v("\n      "+_vm._s(_vm.popupText)+"\n    ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }